export enum ExternalFieldType {
  ENCOMPASS = 'Encompass',
}
